'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.About = exports.CONTAINER_SELECTOR = undefined;

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _ShopifySection2 = require('./../ShopifySection');

var _Parallax = require('../../objects/parallax/Parallax');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 *  About
 *    Scripts to create a paralax effect for the about section.
 *
 *  Version:
 *    1.0.0 - 2020/05/26
 */

var CONTAINER_SELECTOR = exports.CONTAINER_SELECTOR = ' [data-about-image-blocks]';

var About = exports.About = function (_ShopifySection) {
  (0, _inherits3.default)(About, _ShopifySection);

  function About(container) {
    (0, _classCallCheck3.default)(this, About);

    var _this = (0, _possibleConstructorReturn3.default)(this, (About.__proto__ || Object.getPrototypeOf(About)).call(this, container));

    _this.factors = [-0.5, -0.5];
    (0, _Parallax.parallax)(container, _this.factors);
    return _this;
  }

  return About;
}(_ShopifySection2.ShopifySection);

(0, _ShopifySection2.register)(CONTAINER_SELECTOR, About);